module.exports = __webpack_public_path__ + "71c655bfaedaf51e292c0592b0526201.svg";